<template>
    <div class="container" style="height: 100%">
      <ValidationObserver ref="observer" v-if="!loading">
        <v-row>
            <v-col cols="12" sm="6" md="5" lg="3" class="campo">
              <ValidationProvider mode="eager" rules="required" v-slot:default="{ errors }">
                <autocomplete-cadu
                  title="Tipo de Cooperativa"
                  v-model="tipoCooperativa.nome"
                  placeholder=""
                  :errorMessage="errors[0]"
                  :items="listaTiposCooperativa.map(el => el.nome)"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  @input="input => comboIndex(input, 'coop')"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="7" lg="3" class="campo" v-if="mostrarCampoTipoFederacao">
              <ValidationProvider mode="eager" :rules="federacaoComputed ? '' : 'required'" v-slot:default="{ errors }">
                <autocomplete-cadu
                  title="Tipo de Federação"
                  v-model="tipoFederacao.nome"
                  placeholder=""
                  :errorMessage="errors[0]"
                  :items="listaFederacao().map(el => el.nome)"
                  :disabled="federacaoComputed"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  @input="input => comboIndex(input, 'fede')"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="5" md="6" lg="3" class="campo">
              <ValidationProvider mode="eager" :rules="'required'" v-slot:default="{ errors }">
                <autocomplete-cadu
                  title="Tipo de Atuação"
                  v-model="tipoAtuacao.nome"
                  placeholder=""
                  :errorMessage="errors[0]"
                  :items="listaTiposAtuacao.map(el => el.nome)"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  @input="input => comboIndex(input, 'atua')"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="5" md="4" lg="3" class="campo">
              <ValidationProvider mode="eager" rules="required" v-slot:default="{ errors }">
                <autocomplete-cadu
                  :errorMessage="errors[0]"
                  title="Grau da Cooperativa"
                  v-model="grauCooperativa.nome"
                  placeholder=""
                  :items="listaGrauCooperativa.map(el => el.nome)"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  @input="input => comboIndex(input, 'grau')"
                />
              </ValidationProvider>
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" md="3" lg="3" class="campo">
            <ValidationProvider mode="eager" rules="min:6" v-slot:default="{ errors }">
              <input-cadu
                :errorMessage="errors[0]"
                title="Registro ANS"
                placeholder=""
                v-mask="'######'"
                v-model="registroANS"
                :colorText="$vuetify.theme.themes.light.fontColor1"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12" sm="5" md="5" lg="3" class="campo">
              <datepicker-cadu
                  rules="dateValidatorForPass"
                  :menuOpen="menuOpen"
                  inputTitle="Data Reg. Definitivo"
                  placeholder=""
                  validateProviderRules="dateMaiorHoje"
                  :inputValue="dataRegistroDefinitivo"
                  @value="value => dataRegistroDefinitivo = value"
                  typeCalendar="date"
                  width="280"
              ></datepicker-cadu>
          </v-col>
          <v-col cols="12" sm="4" md="4" lg="3" class="campo" v-if="showCancelamento">
              <datepicker-cadu
                  rules="dateValidatorForPass"
                  :menuOpen="menuOpen"
                  inputTitle="Data Cancelamento"
                  ref="cancelamento"
                  placeholder=""
                  :inputValue="dataCancelamento"
                  :validateProviderRules="rulesCancelamento"
                  @value="value => dataCancelamentoValido(value)"
                  typeCalendar="date"
                  width="280"
                ></datepicker-cadu>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="3" class="campo" v-if="showCancelamento">
            <ValidationProvider mode="eager" :rules="motivoDisabled ? '' : 'required|max:300'" v-slot:default="{ errors }">
              <input-cadu
                :errorMessage="errors[0]"
                title="Motivo Cancelamento"
                :disabled="motivoDisabled"
                placeholder=""
                :max="'300'"
                onlyText
                v-model="motivoCancelamento"
                :colorText="$vuetify.theme.themes.light.fontColor1"
              />
            </ValidationProvider>
          </v-col>
      </v-row>
      <v-row v-if="desabilitaCamposPrestadoraOperadora">
          <v-col cols="12" sm="5" md="4" lg="4" class="campo">
               <datepicker-cadu
                  rules="dateValidatorForPass"
                  ref="prestadora"
                  :menuOpen="menuOpen"
                  inputTitle="Data em que virou Não Operadora"
                  placeholder=""
                  validateProviderRules="dateMaiorHoje"
                  :inputValue="dataPrestadora"
                  @value="value => dataPrestadoraValida(value)"
                  typeCalendar="date"
                  width="280"
                ></datepicker-cadu>
          </v-col>
          <v-col cols="12" sm="7" md="6" lg="5" class="campo">
            <ValidationProvider mode="eager" :rules="operadoraDisabled ? '': 'required|max:100'" v-slot:default="{ errors }">
              <autocomplete-cadu
                :errorMessage="errors[0]"
                title="Unimed Operadora Vinculada"
                :disabled="operadoraDisabled"
                placeholder=""
                v-model="unimedVinculada.nome"
                onlyAlphaNum
                :items="listaUnimedVinculada.map(el => el.textoExibicao)"
                :colorText="$vuetify.theme.themes.light.fontColor1"
                @input="input => comboIndex(input, 'vincu')"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row v-if="desabilitaCamposPrestadoraOperadora || desabiltarCampoPrestadora">
            <v-col cols="12" sm="12" md="12" lg="6" class="campo">
              <ValidationProvider mode="eager" :rules="operadoraDisabled ? '' : 'required|max:100'" v-slot:default="{ errors }">
                <autocomplete-cadu
                  :errorMessage="errors[0]"
                  title="Unimed Operadora que Assumiu a Carteira de Beneficiários"
                  :disabled="operadoraDisabled"
                  v-model="unimedCarteira.nome"
                  onlyAlphaNum
                  placeholder=""
                  :items="listaUnimedCarteira.map(el => el.textoExibicao)"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  @input="input => comboIndex(input, 'cart')"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="5" class="campo">
              <ValidationProvider mode="eager" :rules="operadoraDisabled ? '' : 'required|max:100'" v-slot:default="{ errors }">
                <autocomplete-cadu
                  :errorMessage="errors[0]"
                  title="Unimed Operadora que Assumiu a Área de Ação"
                  :disabled="operadoraDisabled"
                  v-model="unimedAreaAcao.nome"
                  onlyAlphaNum
                  placeholder=""
                  :items="listaUnimedAreaAcao.map(el => el.textoExibicao)"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  @input="input => comboIndex(input, 'acao')"
                />
              </ValidationProvider>
            </v-col>
      </v-row>
      </ValidationObserver>
      <component-loading :value="loading"/>
      <modal-cancelar
        v-model="showModalCancelar"
        @cancelar-edicao="cancelarEdicao()"
      />
      <error-modal
        :value="error"
        @input="closeModal"
        :errObj="errObj"
      />
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { isEmpty } from "lodash"
import moment from 'moment'

import TipoCooperativa from '@/services/Dominios/TipoCooperativa'
import TipoAtuacao from '@/services/Dominios/TipoAtuacao'
import GrauCooperativa from '@/services/Dominios/GrauCooperativa'
import Classificacao from '@/services/MinhaUnimed/DadosCadastrais/Classificacao/Classificacao'
import ListarUnimed from '@/services/Unimed/ListarUnimed'

export default {
  directives: {
    mask
  },
  components: {
    ValidationProvider, ValidationObserver
  },

  data () {
    return {
      listaTiposCooperativa: [],
      listaTiposFederacao: [],
      listaTiposAtuacao: [],
      listaGrauCooperativa: [],
      listaUnimedVinculada: [],
      listaUnimedCarteira: [],
      listaUnimedAreaAcao: [],

      tipoCooperativa: {},
      tipoFederacao: {},
      tipoAtuacao: {},
      grauCooperativa: {},
      unimedVinculada: {},
      unimedCarteira: {},
      unimedAreaAcao: {},

      registroANS: '',
      dataRegistroDefinitivo: null,
      dataCancelamento: '',
      motivoCancelamento: '',

      dataPrestadora: '',
      operadoraVinculada: '',

      operadoraCarteiraBeneficiarios: '',
      operadoraAreaAcao: '',

      mostrarCampoTipoFederacao: false,
      desabiltarCampoPrestadora: false,
      desabilitaCamposPrestadoraOperadora: false,
      situacaoUnimed: JSON.parse(localStorage.getItem('situacaoUnimed')),

      teste: false,
      role: '',
      id: '',
      idClassificacao: 0,

      menuOpen: false,

      motivoDisabled: true,
      operadoraDisabled: true,

      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),

      loading: false,
      dadosCadastraisAtiva: false,

      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      objClassificacao: {},
      tipoCooperativaIndex: -1,
      showModalCancelar: false,
      rulesCancelamento: 'dateMaiorHoje',
      tokenBearer: localStorage.getItem('tokenBearer'),
      showCancelamento: false
    }
  },
  async beforeMount () {
    await this.loadAll()
    this.verificaAtuacaoUnimed(this.tipoAtuacao.nome)
  },
  methods: {
    closeModal () {
      this.error = false
    },
    dataPrestadoraValida (value) {
      this.dataPrestadora = value
      let isValid = this.isValidDate(value)
      this.$nextTick(async () => {
        try {
          if (isValid) {
            this.operadoraDisabled = false
            await this.$refs.prestadora.reset()
          } else {
            this.operadoraDisabled = true
            this.operadoraVinculada = ''
            await this.$refs.prestadora.setErrors()
          }
        } catch (err) {}
      })
    },
    dataCancelamentoValido (value) {
      this.dataCancelamento = value
      let isValid = this.isValidDate(value)
      this.$nextTick(async () => {
        try {
          if (isValid) {
            this.motivoDisabled = false
            await this.$refs.cancelamento.reset()
          } else {
            this.motivoDisabled = true
            this.motivoCancelamento = ''
            await this.$refs.cancelamento.setErrors()
          }
        } catch (err) {}
      })
    },
    isValidDate (value) {
      let validDate = moment(value, 'DD/MM/YYYY', true)
      let dataValidada = validDate.isValid()
      let dateBefore = validDate.isAfter()
      validDate.year()

      if (!dateBefore && dataValidada) {
        return true
      } else {
        return false
      }
    },
    verificaAtuacaoUnimed (atuacao) {
      switch (atuacao) {
        case 'INSTITUCIONAL':
        case 'OPERADORA':
        case 'NÃO SE APLICA':
          if (this.situacaoUnimed) {
            this.desabilitaCamposPrestadoraOperadora = false
          } else {
            this.desabiltarCampoPrestadora = true
          }
          break
        case 'PRESTADORA':
          this.desabilitaCamposPrestadoraOperadora = true
          break
        case 'NÃO OPERADORA':
          this.desabilitaCamposPrestadoraOperadora = true
          break
      }
    },
    async loadAll () {
      this.loading = true
      await this.getListarUnimed()
      await this.carregaListas()
      await this.getAllClassificacao()
      this.loading = false
    },
    async getListarUnimed () {
      let listarUnimed = new ListarUnimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseListarUnimed = await listarUnimed.getAll()
        responseListarUnimed = responseListarUnimed.data

        this.listaUnimedVinculada = responseListarUnimed
        this.listaUnimedCarteira = responseListarUnimed
        this.listaUnimedAreaAcao = responseListarUnimed
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    listaFederacao () {
      return this.listaTiposFederacao[this.tipoCooperativaIndex] ? this.listaTiposFederacao[this.tipoCooperativaIndex] : []
    },
    verificaTipoCooperativa (cooperativa) {
      switch (cooperativa) {
        case 'FEDERAÇÃO':
        case 'CONFEDERAÇÃO':
          this.mostrarCampoTipoFederacao = true
          break
        default:
          this.tipoFederacao = {}
          this.mostrarCampoTipoFederacao = false
      }
    },
    comboIndex (input, type) {
      let fun = (element) => {
        return element.nome === input
      }
      let objCombo = {}
      if (input !== undefined && input !== null) {
        switch (type) {
          case 'coop':
            this.tipoCooperativa.nome = input
            let index = this.listaTiposCooperativa.findIndex(fun)
            this.tipoCooperativa.id = index !== -1 ? this.listaTiposCooperativa[index].id : null
            this.verificaTipoCooperativa(input)
            this.tipoCooperativaIndex = index
            break
          case 'fede':
            this.tipoFederacao.nome = input
            objCombo = this.listaFederacao().find(fun)
            this.tipoFederacao.id = objCombo ? objCombo.id : null
            break
          case 'atua':
            this.tipoAtuacao.nome = input
            this.verificaAtuacaoUnimed(input)
            objCombo = this.listaTiposAtuacao.find(fun)
            this.tipoAtuacao.id = objCombo ? objCombo.id : null
            this.showCancelamento = input !== 'OPERADORA' && (input !== null || input !== '')
            break
          case 'grau':
            this.grauCooperativa.nome = input
            objCombo = this.listaGrauCooperativa.find(fun)
            this.grauCooperativa.id = objCombo ? objCombo.id : null
            break
          case 'vincu':
            this.unimedVinculada.nome = input
            objCombo = this.listaUnimedVinculada.find((element) => {
              return element.textoExibicao === input
            })
            this.unimedVinculada.id = objCombo ? objCombo.id : null
            break
          case 'cart':
            this.unimedCarteira.nome = input
            objCombo = this.listaUnimedCarteira.find((element) => {
              return element.textoExibicao === input
            })
            this.unimedCarteira.id = objCombo ? objCombo.id : null
            break
          case 'acao':
            this.unimedAreaAcao.nome = input
            objCombo = this.listaUnimedAreaAcao.find((element) => {
              return element.textoExibicao === input
            })
            this.unimedAreaAcao.id = objCombo ? objCombo.id : null
            break
          default:
            break
        }
      }
    },
    async carregaListas () {
      await this.listaCooperativas()
      await this.listaAtuacao()
      await this.listaGrau()
    },

    async getAllClassificacao () {
      let classificacao = new Classificacao(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseClassificacao = await classificacao.getClassificacao()
        let resClas = responseClassificacao.data

        this.tipoCooperativa = resClas.tipoUnimed ? resClas.tipoUnimed : {}
        this.tipoFederacao = resClas.tipoFederacao ? resClas.tipoFederacao : {}
        this.tipoAtuacao = resClas.tipoAtuacao ? resClas.tipoAtuacao : {}
        this.grauCooperativa = resClas.grauCooperativa ? resClas.grauCooperativa : {}

        this.registroANS = resClas.registroAns
        this.dataRegistroDefinitivo = resClas.dataRegistroDefinitivo
      } catch (err) {
        console.error(err)
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },

    async listaCooperativas () {
      const tipoCooperativa = new TipoCooperativa(this.tokenBearer, this.$appConfig.config.API)

      try {
        const res = await tipoCooperativa.getTipoCooperativa()
        res.data.forEach((item) => {
          this.listaTiposCooperativa.push(item)
          this.listaTiposFederacao.push(item.tiposFederacao)
        })
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async listaAtuacao () {
      const tipoAtuacao = new TipoAtuacao(this.tokenBearer, this.$appConfig.config.API)

      try {
        const res = await tipoAtuacao.getTipoAtuacao()
        this.listaTiposAtuacao = res.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async listaGrau () {
      const tipoGrau = new GrauCooperativa(this.tokenBearer, this.$appConfig.config.API)

      try {
        const res = await tipoGrau.getGrauCooperativa()
        this.listaGrauCooperativa = res.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async validateForm () {
      let res = await this.$refs.observer.validate()

      if (res) {
        let tipoAtuacao = this.tipoAtuacao.id ? { id: this.tipoAtuacao.id } : null
        let tipoUnimed = this.tipoCooperativa.id ? { id: this.tipoCooperativa.id } : null
        let grauCooperativa = this.grauCooperativa.id ? { id: this.grauCooperativa.id } : null
        let tipoFederacao = this.tipoFederacao.id ? { id: this.tipoFederacao.id } : null
        let dataCancelamento = this.dataCancelamento ? this.dataCancelamento : null
        let motivoCancelamento = this.motivoCancelamento ? this.motivoCancelamento : null
        let unimedOperadoraAreaDeAcao = isEmpty(this.unimedAreaAcao) ? [] : this.unimedAreaAcao

        let obj = {
          dataCancelamento,
          motivoCancelamento,
          dataRegistroDefinitivo: this.dataRegistroDefinitivo,
          grauCooperativa,
          id: null,
          registroAns: this.registroANS,
          tipoAtuacao,
          tipoFederacao,
          tipoUnimed,
          unimedOperadoraAreaDeAcao,
          unimedOperadoraCarteira: this.unimedCarteira,
          unimedOperadoraVinculada: this.unimedVinculada
        }

        let classificacao = new Classificacao(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

        try {
          await classificacao.putClassificacao(obj)
          return true
        } catch (err) {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
          return false
        }
      }
      return res
    }
  },
  computed: {
    // eslint-disable-next-line
    federacaoComputed () {
      return false
    }
  }
}
</script>

<style scoped>

</style>
